import * as tslib_1 from "tslib";
import { MESSAGECONSTANTS } from 'src/app/core/utils/constants';
var EmailDocumentsController = /** @class */ (function () {
    /*@ngInject*/
    function EmailDocumentsController($rootScope, $timeout, $uibModal, modalService, documentService, alertsAndNotificationsService, documentActionService, userService, jobMatchService, sharedAjsService, llmIntegrationService) {
        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
        this.$timeout = $timeout;
        this.modalService = modalService;
        this.documentService = documentService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.documentActionService = documentActionService;
        this.userService = userService;
        this.jobMatchService = jobMatchService;
        this.sharedAjsService = sharedAjsService;
        this.llmIntegrationService = llmIntegrationService;
    }
    EmailDocumentsController.prototype.$onInit = function () {
        var _this = this;
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.userId = this.$rootScope.userDetails.id;
        this.loggedIdCompanyName = this.$rootScope.userDetails.company.companyName;
        this.loggedInUserName = this.$rootScope.userDetails.firstname + " " + this.$rootScope.userDetails.lastname;
        this.isStaffingCompany = this.$rootScope.userDetails.company.companyType === 'StaffingCompany';
        this.loggedInUserEmailId = this.$rootScope.userDetails.emailId;
        this.attachedDocuments = [];
        this.documentsSectionHtml = '';
        this.availableDocuments = [];
        this.selectedEmailSendToObjectsArray = [];
        this.selectedEmailCCObjectsArray = [];
        this.selectedEmailBCCObjectsArray = [];
        this.defaultCandidateEmail = null;
        this.userSearchPlaceholder = 'Type email to search.';
        this.emailDocumentFolderId = null;
        this.selectedJobMatchList = [];
        this.candidateAssessmentFiles = [];
        this.candidateInformationList = [];
        this.addedEmailCount = 0;
        this.savingFlag = false;
        this.isRequisitionUsersSelected = true;
        this.emailDetails = {
            documentIds: [],
            emailUsers: [],
            subject: "",
            ccUsers: [],
            bccUsers: [],
            body: ""
        };
        this.searchUsersForEmail = null;
        var defaultLoggedInUserEmail = {
            id: this.userId,
            email: this.loggedInUserEmailId,
            displayString: "",
            name: "" + this.loggedInUserName,
            isCompanyUser: this.isStaffingCompany
        };
        if (this.candidateDetails && this.candidateDetails.candidateEmail) {
            this.emailDetails.emailUsers.push({ email: this.candidateDetails.candidateEmail });
            this.defaultCandidateEmail = {
                id: this.candidateDetails.candidateId,
                email: this.candidateDetails.candidateEmail,
                displayString: "",
                name: "" + this.candidateDetails.candidateEmail
            };
            this.selectedEmailSendToObjectsArray.push(this.defaultCandidateEmail);
            // Add Logged in user to cc list
            this.emailDetails.ccUsers.push({ email: this.loggedInUserEmailId });
            this.selectedEmailCCObjectsArray.push(defaultLoggedInUserEmail);
        }
        else {
            this.emailDetails.ccUsers.push({ email: this.loggedInUserEmailId });
            this.selectedEmailCCObjectsArray.push(defaultLoggedInUserEmail);
        }
        if (this.candidateDetails) {
            this.candidateId = this.candidateDetails.candidateId;
            this.jobMatchId = this.candidateDetails.jobMatchId;
            if (this.candidateDetails.candidateEmailSubjectAndBodyInformation) {
                this.emailDetails.subject = this.candidateDetails.candidateEmailSubjectAndBodyInformation.subject;
                this._setEmailBodyPrePopulatedInformation(null);
                this.candidateInformationList = _.cloneDeep(this.candidateDetails.candidateEmailSubjectAndBodyInformation.candidateInfoInEmailBody);
            }
        }
        if (this.candidateDetails && !this.candidateId && this.document) {
            this.candidateId = this.document.candidateId;
        }
        if (this.documents && this.document) {
            this.availableDocuments = this.documents;
            this.attachedDocuments = this.documents.filter(function (doc) { return doc.id === _this.document.id; });
            this.attachedDocuments.forEach(function (doc) {
                doc.selected = true;
            });
        }
        this.uploadEmailDocumentResponse = null;
        this.fileUploadInProgressFlag = false;
        this.disableUploadButtonFlag = false;
        this.isAttachDocuments = false;
        this.isCandidateJobMatch = false;
        this.isExistingDocumentsAvailable = false;
        this.isPrePopulatedUsersAvailable = false;
        this.showClientForReviewCheckbox = false;
        this.selectAllCandidates = false;
        this.selectAllCandidatesExternal = false;
        this.externalCandidateAction = null;
        this.isSendForReviewSelected = false;
        this.selectedCandidateFieldsForReview = [];
        if (!this.folders && !this.candidateJobMatchFolders) {
            // Pre populate users in candidate workflow
            if (this.candidateDetails.context == 'candidateJobMatchCard') {
                // Set Email CC,BCC,CC Search
                this.candidateJobMatchFolders = [];
                this._setUserToEmailSearchObject();
                this._setPrePopulatedEmailUsersList(this.candidateDetails.jobMatchId);
            }
            this.getAllCandidateFolders(null, function () { });
        }
        else {
            // From candidate documents to email
            // Pre populate users in candidate workflow
            if (this.candidateDetails.context == 'candidateJobMatchCard') {
                if (this.candidateDetails.jobMatchId) {
                    this.candidateJobMatchFolders = this.candidateJobMatchFolders.filter(function (jobMatch) { return _this.candidateDetails.jobMatchId == jobMatch.jobMatch.jobMatchId; });
                    this._setPrePopulatedEmailUsersList(this.candidateDetails.jobMatchId);
                }
            }
            else {
                // Pre populate users in candidate card
                this._setPrePopulatedEmailUsersList();
            }
            this.isExistingDocumentsAvailable = true;
            this._setUserToEmailSearchObject();
            this.isPrePopulatedUsersAvailable = true;
        }
        //initialize the drop zone configuration
        this.$timeout(function () {
            _this.emailDocumentUploadDropzone = _this.createEmailDocumentUploadDropZone();
        }, 200);
        // Initialize height adjustment for attached documents section
        this.$timeout(function () {
            _this.adjustAttachedDocumentsHeight();
        }, 300);
        this._setCandidateAssessmentReports();
        this.inputTypeAheadText = {
            emailUsers: '',
            ccUsers: '',
            bccUsers: ''
        };
        // this._setCandidateInformationInBody();
        this._handleFilterDisplay();
        // store original signature (if any) so we can re-append after formalization
        this._emailSignature = this.emailDetails.body || '';
    };
    // Receive formalized email content from downgraded FormalizeComment component
    EmailDocumentsController.prototype.receiveFormalizedEmail = function (output) {
        if (!output)
            return;
        if (output.subject) {
            this.emailDetails.subject = output.subject;
        }
        if (output.body) {
            if (output.isHtml) {
                this.emailDetails.body = output.body + (this._emailSignature || '');
                this.displayedBody = this.emailDetails.body;
            }
            else {
                // Legacy plain-text path: wrap in <p> tags and re-attach signature.
                var bodyPlain = output.body.toString().trim();
                // Remove pre-populated signature (if present) from the formalized output.
                var signatureHtml = this._emailSignature || '';
                var signatureText = signatureHtml.replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim();
                if (signatureText) {
                    var bodyLower = bodyPlain.toLowerCase();
                    var sigLower = signatureText.toLowerCase();
                    if (bodyLower.endsWith(sigLower)) {
                        bodyPlain = bodyPlain.slice(0, bodyPlain.length - signatureText.length).trim();
                    }
                    else {
                        var idx = bodyLower.lastIndexOf(sigLower);
                        if (idx !== -1) {
                            bodyPlain = bodyPlain.slice(0, idx).trim();
                        }
                    }
                }
                var htmlBody = bodyPlain.split(/\n{1,}/).map(function (p) { return "<p>" + p.trim() + "</p>"; }).join('');
                this.emailDetails.body = htmlBody + (this._emailSignature || '');
                this.displayedBody = this.emailDetails.body;
            }
        }
        this.alertsAndNotificationsService.showBannerMessage('Email content enhanced by AI.', 'success');
    };
    /**
     * creates the email upload drop zone.
     */
    EmailDocumentsController.prototype.createEmailDocumentUploadDropZone = function () {
        var _this = this;
        var dropZoneSettings = this._getDropZoneSettings();
        var emailDocumentUploadDropzone = new Dropzone("form#emailDocumentUploadDropzone", dropZoneSettings);
        // add event handlers for the drop zone
        emailDocumentUploadDropzone.on('addedfile', function (file, response) {
            _this.fileUploadInProgressFlag = true;
            _this.disableUploadButtonFlag = true;
            if (file) {
                $(".dz-preview").remove();
                _this.uploadEmailDocumentToUpload();
            }
        });
        emailDocumentUploadDropzone.on('removedfile', function (file, response) { });
        emailDocumentUploadDropzone.on('sendingmultiple', function (file, xhr, formData) {
            formData.append('companyId', _this.companyId);
            formData.append('candidateId', _this.candidateId);
            formData.append('internalNote', "");
            formData.append('sharedEntityIds', null);
            formData.append('shareDocument', false);
            formData.append('folderId', _this.emailDocumentFolderId);
            formData.append('candidateType', _this.candidateDetails.candidateType);
            formData.append('userId', _this.userId);
        });
        emailDocumentUploadDropzone.on('successmultiple', function (fileArray, response) {
            // remove file upload in progress flag
            _this.uploadEmailDocumentResponse = response;
            if (response) {
                _this._setAttachedDocuments(response);
            }
            else {
                _this.fileUploadInProgressFlag = false;
                _this.disableUploadButtonFlag = false;
            }
            _this.alertsAndNotificationsService.showBannerMessage("Document(s) added successfully.", "success");
        });
        emailDocumentUploadDropzone.on("complete", function (file) {
            emailDocumentUploadDropzone.removeAllFiles();
        });
        emailDocumentUploadDropzone.on("error", function (file, error) {
            _this.fileUploadInProgressFlag = false;
            var errorMessage = error.message ? error.message : error;
            _this.alertsAndNotificationsService.showBannerMessage(errorMessage, "error");
            _this.fileUploadInProgressFlag = false;
            _this.disableUploadButtonFlag = false;
        });
        return emailDocumentUploadDropzone;
    };
    EmailDocumentsController.prototype._getDropZoneSettings = function () {
        var dropZoneSettings = {};
        var maxFilesToUpload = 2;
        dropZoneSettings = {
            url: this.documentService.getUploadUrl(),
            paramName: function () {
                return "files";
            },
            acceptedFiles: ".pdf,.xlsx,.docx,.doc",
            maxFiles: maxFilesToUpload,
            maxFilesize: 10,
            maxThumbnailFilesize: 10,
            timeout: 300000,
            addRemoveLinks: true,
            autoProcessQueue: false,
            uploadMultiple: true,
            parallelUploads: 100
        };
        return dropZoneSettings;
    };
    EmailDocumentsController.prototype._buildDocumentsSectionHtml = function () {
        var _this = this;
        var selectedAssessments = (this.candidateAssessmentFiles || []).filter(function (f) { return f.isSelected; });
        var hasAttached = this.attachedDocuments && this.attachedDocuments.length > 0;
        if (!hasAttached && selectedAssessments.length === 0) {
            this.documentsSectionHtml = '';
            return;
        }
        var html = '<p id="doc-attach-header"><b>Document(s) attached:-</b></p>';
        selectedAssessments.forEach(function (file) {
            html += "<p><b>" + file.name + ":</b> " + file.resumeNameOrXrXml + "</p>";
        });
        if (hasAttached) {
            this.attachedDocuments.forEach(function (doc) {
                if (doc.isJobMatchDocument) {
                    // Use displayLabel and displayFileName from document object
                    var displayLabel = doc.displayLabel || doc.fileName;
                    var displayFileName = doc.displayFileName || doc.fileName;
                    html += "<p><b>" + displayLabel + ":</b> " + displayFileName + "</p>";
                }
                else {
                    var label = _this._getDocumentLabel(doc);
                    if (label) {
                        html += "<p><b>" + label + ":</b> " + doc.fileName + "</p>";
                    }
                    else {
                        html += "<p><b>" + doc.fileName + "</b></p>";
                    }
                }
            });
        }
        html += '<p><br/></p>';
        this.documentsSectionHtml = html;
    };
    EmailDocumentsController.prototype.onAssessmentFileChange = function () {
        this._buildDocumentsSectionHtml();
    };
    EmailDocumentsController.prototype._getDocumentLabel = function (doc) {
        var e_1, _a, e_2, _b;
        if (doc.folderId && this.folders) {
            try {
                for (var _c = tslib_1.__values(this.folders), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var folder = _d.value;
                    if (folder.id === doc.folderId) {
                        if (folder.name === 'Resume')
                            return 'Resume';
                        if (folder.name === 'Technical Assessment')
                            return 'Technical Assessment';
                        return null;
                    }
                    if (folder.folders) {
                        try {
                            for (var _e = tslib_1.__values(folder.folders), _f = _e.next(); !_f.done; _f = _e.next()) {
                                var subFolder = _f.value;
                                if (subFolder.id === doc.folderId) {
                                    if (subFolder.name === 'Resume')
                                        return 'Resume';
                                    if (subFolder.name === 'Technical Assessment')
                                        return 'Technical Assessment';
                                    if (folder.name === 'Resume')
                                        return 'Resume';
                                    if (folder.name === 'Technical Assessment')
                                        return 'Technical Assessment';
                                    return null;
                                }
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return null;
    };
    EmailDocumentsController.prototype._setAttachedDocuments = function (response) {
        var _this = this;
        this.getAllCandidateFolders(response, function () {
            _this.fileUploadInProgressFlag = false;
            _this.disableUploadButtonFlag = false;
        });
    };
    EmailDocumentsController.prototype.attachDocument = function (document) {
        var checkIfDocExists = false;
        this.attachedDocuments.every(function (doc) {
            if (doc.id === document.id) {
                checkIfDocExists = true;
                return false;
            }
            return true;
        });
        if (!checkIfDocExists) {
            this.attachedDocuments.push(document);
            this._buildDocumentsSectionHtml();
        }
    };
    EmailDocumentsController.prototype.detachDocument = function (document) {
        this.attachedDocuments = this.attachedDocuments.filter(function (doc) { return doc.id !== document.id; });
        this._buildDocumentsSectionHtml();
    };
    EmailDocumentsController.prototype._setJobMatchSelectedDocumentObj = function (jobMatchDocument) {
        var tempObj = {
            jobId: jobMatchDocument.jobMatch.jobId,
            jobMatchTitle: jobMatchDocument.jobMatch.jobMatchTitle,
            jobMatchRequisitionNum: jobMatchDocument.jobMatch.jobMatchRequisitionNum,
            jobMatchId: jobMatchDocument.jobMatch.jobMatchId,
            testInvitationId: null,
            sendRecruiterScreeningFeedbackReport: false,
            sendPhoneScreeningFeedbackReport: false,
            sendInterviewFeedbackReport: false,
            sendTechAssessmentReport: false,
            sendOutreachFeedbackReport: false
        };
        switch (jobMatchDocument.fileName) {
            case 'Tech Assessment':
                tempObj.testInvitationId = jobMatchDocument.jobMatch.techAssessmentInvitationId;
                tempObj.sendTechAssessmentReport = true;
                break;
            case 'Value Assessment':
                tempObj.valueAssessmentInvitationId = jobMatchDocument.jobMatch.valueAssessmentInvitationId;
                tempObj.sendValueAssessmentReport = true;
                break;
            case 'Recruiter Screening Feedback':
                tempObj.sendRecruiterScreeningFeedbackReport = true;
                break;
            case 'Phone Screen Feedback':
                tempObj.sendPhoneScreeningFeedbackReport = true;
                break;
            case 'Interview Feedback':
                tempObj.sendInterviewFeedbackReport = true;
                break;
            case 'Outreach Feedback':
                tempObj.sendOutreachFeedbackReport = true;
                break;
            default:
                break;
        }
        return tempObj;
    };
    EmailDocumentsController.prototype._setCandidateDocumentsToEmail = function () {
        var _this = this;
        var candidateDocuments = [];
        var allFolders = [];
        this.folders.map(function (parentFolder) {
            allFolders.push(parentFolder);
            if (parentFolder.folders && parentFolder.folders.length > 0) {
                parentFolder.folders.map(function (childFolder) { return allFolders.push(childFolder); });
            }
        });
        this.attachedDocuments.map(function (document) {
            if (!document.isJobMatchDocument) {
                var tempDocument = {};
                tempDocument.documentId = document.id;
                tempDocument.documentName = document.fileName;
                tempDocument.folderId = document.folderId;
                _this.documentActionService.setParentAndChildFolderName(allFolders, tempDocument);
                candidateDocuments.push(tempDocument);
            }
        });
        return candidateDocuments;
    };
    EmailDocumentsController.prototype._setJobMatchesDocumentsToEmail = function () {
        var _this = this;
        var selectedJobMatchDocuments = this.attachedDocuments.filter(function (doc) { return doc.isJobMatchDocument; });
        var emailJobMatchObjList = [];
        if (selectedJobMatchDocuments.length > 0) {
            selectedJobMatchDocuments.map(function (jobMatchDocument) {
                emailJobMatchObjList.push(_this._setJobMatchSelectedDocumentObj(jobMatchDocument));
            });
        }
        return emailJobMatchObjList;
    };
    EmailDocumentsController.prototype._setCandidateResumesToEmail = function (type) {
        if (this.candidateAssessmentFiles.length > 0) {
            var assessmentDocument_1;
            this.candidateAssessmentFiles.map(function (data) {
                if (data.name == type) {
                    assessmentDocument_1 = data;
                }
            });
            return assessmentDocument_1.isSelected;
        }
        else {
            return false;
        }
    };
    EmailDocumentsController.prototype._mapCandidateFieldsToReviewFormat = function () {
        var _this = this;
        // Mapping based on actual field names coming from the data
        var fieldMappingByName = {
            'Full Name': { key: 'FULL_NAME', label: 'Full Name' },
            'Phone Number': { key: 'PHONE_NUMBER', label: 'Phone Number' },
            'Email': { key: 'EMAIL', label: 'Email' },
            'Address': { key: 'ADDRESS', label: 'Address' },
            'Current Location': { key: 'CURRENT_LOCATION', label: 'Current Location' },
            'Current Role': { key: 'CURRENT_ROLE', label: 'Current Role' },
            'Current Company': { key: 'CURRENT_COMPANY', label: 'Current Company' },
            'Seeking Job Type': { key: 'SEEKING_JOB_TYPE', label: 'Seeking Job Type' },
            'Desired Salary/Rate': { key: 'DESIRED_SALARY_RATE', label: 'Desired Salary/Rate' },
            'Sponsorship': { key: 'SPONSORSHIP', label: 'Sponsorship' },
            'Willing To Relocate': { key: 'WILLING_TO_RELOCATE', label: 'Willing to Relocate' },
            'Willing to Relocate': { key: 'WILLING_TO_RELOCATE', label: 'Willing to Relocate' },
            'Linkedin Url': { key: 'LINKEDIN_URL', label: 'LinkedIn URL' },
            'LinkedIn URL': { key: 'LINKEDIN_URL', label: 'LinkedIn URL' }
        };
        // Fallback mapping by ID pattern for older data structure
        var fieldMappingById = {
            'name': { key: 'FULL_NAME', label: 'Full Name' },
            'phone_number': { key: 'PHONE_NUMBER', label: 'Phone Number' },
            'email': { key: 'EMAIL', label: 'Email' },
            'address': { key: 'ADDRESS', label: 'Address' },
            'current_location': { key: 'CURRENT_LOCATION', label: 'Current Location' },
            'current_role': { key: 'CURRENT_ROLE', label: 'Current Role' },
            'current_company': { key: 'CURRENT_COMPANY', label: 'Current Company' },
            'seeking_job_type': { key: 'SEEKING_JOB_TYPE', label: 'Seeking Job Type' },
            'desired_salary.rate': { key: 'DESIRED_SALARY_RATE', label: 'Desired Salary/Rate' },
            'sponsorship': { key: 'SPONSORSHIP', label: 'Sponsorship' },
            'willing_to_relocate': { key: 'WILLING_TO_RELOCATE', label: 'Willing to Relocate' },
            'linkedin_url': { key: 'LINKEDIN_URL', label: 'LinkedIn URL' }
        };
        var clientReviewIncludeFields = [];
        var displayOrder = 1; // Start from 1, increment based on selection order
        // Get selected fields - prefer emitted selectedFields, fallback to candidateInformationList
        var fieldsToProcess = this.selectedCandidateFieldsForReview;
        // Fallback: if no emitted fields, get selected fields from candidateInformationList
        if ((!fieldsToProcess || fieldsToProcess.length === 0) && this.candidateInformationList && this.candidateInformationList.length > 0) {
            fieldsToProcess = this.candidateInformationList.filter(function (c) { return c.selected; });
        }
        if (fieldsToProcess && fieldsToProcess.length > 0) {
            fieldsToProcess.forEach(function (field, index) {
                // Try mapping by name first (for actual candidate data)
                var fieldMap = fieldMappingByName[field.name];
                // Fallback to mapping by ID (for legacy data)
                if (!fieldMap) {
                    fieldMap = fieldMappingById[field.id];
                }
                // If no mapping found, generate one generically
                if (!fieldMap) {
                    // Generate fieldKey from field name (e.g., "Sponsorship Notes" -> "SPONSORSHIP_NOTES")
                    var generatedKey = (field.name || field.id)
                        .toUpperCase()
                        .replace(/\s+/g, '_')
                        .replace(/[/\-]/g, '_');
                    fieldMap = {
                        key: generatedKey,
                        label: field.name || field.id
                    };
                }
                var fieldValue = _this._getFieldValue(field);
                clientReviewIncludeFields.push({
                    fieldKey: fieldMap.key,
                    fieldLabel: fieldMap.label,
                    fieldValue: fieldValue,
                    displayOrder: displayOrder // Use current displayOrder, then increment
                });
                displayOrder++; // Increment for next field
            });
        }
        return clientReviewIncludeFields;
    };
    EmailDocumentsController.prototype._getFieldValue = function (field) {
        // Extract the actual field value, handling test values and empty strings
        if (!field || !field.value) {
            return 'Not Specified';
        }
        var valueStr = field.value.toString().trim();
        if (valueStr === '') {
            return 'Not Specified';
        }
        return valueStr;
    };
    EmailDocumentsController.prototype._setEmailDetails = function () {
        var emailDetails = {
            candidateId: this.candidateId,
            userId: this.userId,
            candidateType: this.candidateDetails.candidateType,
            companyId: this.companyId,
            jobMatchId: this.candidateDetails.jobMatchId,
            candidateDocuments: {
                documents: this._setCandidateDocumentsToEmail(),
                sendResume: this._setCandidateResumesToEmail('Resume'),
                sendResumeHRXML: this._setCandidateResumesToEmail('Resume HR Xml')
            },
            jobMatchesDocuments: this._setJobMatchesDocumentsToEmail(),
            currentStep: this.candidateDetails.currentStep,
            emailDetails: {
                emailUsers: this.emailDetails.emailUsers,
                subject: this.emailDetails.subject,
                ccUsers: this.emailDetails.ccUsers,
                bccUsers: this.emailDetails.bccUsers,
                body: this.emailDetails.body
            }
        };
        // Add client review fields if "Send to Client for Review" is selected
        if (this.isSendForReviewSelected) {
            emailDetails.emailDetails.sentToClientForReview = true;
            emailDetails.emailDetails.clientReviewIncludeFields = this._mapCandidateFieldsToReviewFormat();
        }
        return emailDetails;
    };
    EmailDocumentsController.prototype._checkIfMoreThanTwoCompanyEmailIdsExists = function () {
        var allClientOrBuNames = [];
        var allSelectedEmailTagObjects = tslib_1.__spread(this.selectedEmailSendToObjectsArray, this.selectedEmailCCObjectsArray, this.selectedEmailBCCObjectsArray);
        if (allSelectedEmailTagObjects.length > 1) {
            if (this.isStaffingCompany) {
                allSelectedEmailTagObjects.map(function (data) {
                    if (data.companyName) {
                        allClientOrBuNames.push(data.companyName);
                    }
                });
                // filter unique client names.
                var uniqueClientOrBuSet = new Set(allClientOrBuNames);
                return uniqueClientOrBuSet.size !== 1;
            }
            else {
                allSelectedEmailTagObjects.map(function (data) {
                    allClientOrBuNames.push(data.staffingCompany);
                });
                // filter unique bu names.
                var uniqueClientOrBuSet = new Set(allClientOrBuNames);
                return uniqueClientOrBuSet.size !== 1;
            }
        }
        else {
            return false;
        }
    };
    EmailDocumentsController.prototype._checkIfNonCompanyEmailExists = function (emailDetails) {
        var allSelectedEmailTagObjects = tslib_1.__spread(this.selectedEmailSendToObjectsArray, this.selectedEmailCCObjectsArray, this.selectedEmailBCCObjectsArray);
        if (allSelectedEmailTagObjects.length > 0) {
            var nonCompanyEmailExists_1 = false;
            allSelectedEmailTagObjects.map(function (data) {
                if (!data.id || data.id.toString().length < 3) {
                    nonCompanyEmailExists_1 = true;
                }
            });
            return nonCompanyEmailExists_1;
        }
        else {
            return false;
        }
    };
    EmailDocumentsController.prototype._sendMail = function (emailDetails) {
        var _this = this;
        this.savingFlag = true;
        this.documentService.emailDocuments(emailDetails, function (data) {
            _this.alertsAndNotificationsService.showBannerMessage("Email sent successfully", "success");
            _this.savingFlag = false;
            if (_this.saveCallback) {
                _this.saveCallback();
            }
        }, function (error) {
            _this.savingFlag = false;
            _this.alertsAndNotificationsService.showBannerMessage(error.message, "danger");
        });
    };
    EmailDocumentsController.prototype.sendMail = function () {
        var _this = this;
        this.emailDocumentsForm.$submitted = true;
        if (!this.emailDocumentsForm.$invalid) {
            // CRITICAL: Sync editor content to model before preparing email details
            this._syncEditorContentToModel();
            var emailDetails_1 = this._setEmailDetails();
            if (this._checkIfMoreThanTwoCompanyEmailIdsExists(emailDetails_1) || this._checkIfNonCompanyEmailExists(emailDetails_1)) {
                this.savingFlag = true;
                var clientOrBu = this.$rootScope.userDetails.company.companyType == "Corporation" ? "BU" : "Client";
                var title = "Different " + clientOrBu;
                var message = "<div>\n                                    <p>Email and/or document(s) being sent to email address(es) outside the company.<p>\n                                    <p>Send anyway?</p>\n                               </div>";
                this.alertsAndNotificationsService.showConfirm(title, message, "warning", false, function () {
                    _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                    _this._sendMail(emailDetails_1);
                }, function () {
                    //do nothing
                    _this.savingFlag = false;
                    _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                });
            }
            else {
                this._sendMail(emailDetails_1);
            }
        }
    };
    EmailDocumentsController.prototype.cancel = function () {
        if (this.cancelCallback) {
            this.cancelCallback();
        }
    };
    /**
     * Syncs the editor DOM content back to the model to ensure all typed/edited content is captured
     */
    EmailDocumentsController.prototype._syncEditorContentToModel = function () {
        var editorElem = document.querySelector('app-ngx-editor [contenteditable="true"]');
        if (editorElem && editorElem.innerHTML) {
            this.emailDetails.body = editorElem.innerHTML;
        }
    };
    EmailDocumentsController.prototype.attachDocuments = function (document) {
        var _this = this;
        var actionType = 'attachDocuments';
        var actionLabel = 'Attach Document';
        var windowTopClass = "four-dot-five-modal-large";
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        $(".modal").addClass("candidate-documents-modal");
        this.$timeout(function () {
            var candidateProfileActionsModal = _this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                windowTopClass: windowTopClass,
                component: 'candidateProfileActionsModal',
                resolve: {
                    actionType: function () {
                        return actionType;
                    },
                    actionLabel: function () {
                        return actionLabel;
                    },
                    documents: function () {
                        return _.cloneDeep(_this.attachedDocuments);
                    },
                    availableDocuments: function () {
                        return _this.availableDocuments;
                    },
                    folders: function () {
                        return _this.folders;
                    },
                    candidateJobMatchFolders: function () {
                        return _this.candidateJobMatchFolders;
                    }
                }
            });
            candidateProfileActionsModal.result.then(function (callbackObject) {
                if (callbackObject.entity && callbackObject.entity.length > 0) {
                    _this.attachedDocuments = callbackObject.entity;
                    _this._buildDocumentsSectionHtml();
                    // callbackObject.entity.forEach(doc => {
                    //     this.attachDocument(doc);
                    // });
                }
            }, function (dismiss) {
                //do nothing;
            });
        }, 300);
    };
    EmailDocumentsController.prototype._setCandidateJobMatchFolders = function (jobMatches) {
        this.candidateJobMatchFolders = [];
        this.candidateJobMatchFolders = this.documentActionService.setCandidateJobMatchFolders(jobMatches, this.companyId, this.candidateId);
    };
    EmailDocumentsController.prototype._setFolders = function (folders) {
        folders.forEach(function (folder) {
            folder.folders.forEach(function (subFolder) {
                subFolder.parentFolderId = folder.id;
                subFolder.parentFolderName = folder.name;
            });
        });
        this.folders = folders;
        this.documentActionService._setDocumentIcons(this.folders);
    };
    EmailDocumentsController.prototype.getAllCandidateFolders = function (response, successCallback) {
        var _this = this;
        var candidateType = this.candidateType ? this.candidateType : this.candidateDetails.candidateType;
        this.documentService.getAllCandidateFolders(this.candidateId, this.companyId, candidateType, function (data) {
            _this._setFolders(data.candidateDocuments);
            if (_this.candidateDetails && _this.candidateDetails.context === 'candidateJobMatchCard') {
                var currentCandidateJobMatch = data.jobMatchesDocuments.filter(function (jobMatch) { return _this.candidateDetails.jobMatchId == jobMatch.jobMatchId; });
                _this._setCandidateJobMatchFolders(currentCandidateJobMatch);
            }
            else {
                _this._setCandidateJobMatchFolders(data.jobMatchesDocuments);
            }
            _this.folders = _this.documentActionService.setSharedFolderWithDocuments(_this.folders, _this.candidateId, _this.companyId);
            var allDocuments = [];
            var parentDocuments = [];
            var childDocuments = [];
            _this.folders.map(function (folder) {
                if (folder.name === 'Email Documents') {
                    _this.emailDocumentFolderId = folder.id;
                }
                parentDocuments = tslib_1.__spread(folder.documents);
                childDocuments = [];
                folder.folders.forEach(function (subFolder) {
                    childDocuments = tslib_1.__spread(childDocuments, subFolder.documents);
                });
                allDocuments = tslib_1.__spread(allDocuments, parentDocuments, childDocuments);
            });
            //available documents
            _this.availableDocuments = allDocuments;
            if (response) {
                // attached documents  
                response.map(function (document) {
                    var index = _.findIndex(allDocuments, {
                        fileName: document.fileName
                    });
                    allDocuments[index].selected = true;
                    _this.attachedDocuments.push(allDocuments[index]);
                });
            }
            else if (!_this.documents || !_this.document) {
                _this.attachedDocuments = [];
            }
            if (_this.candidateDetails.context != 'candidateJobMatchCard') {
                _this._setUserToEmailSearchObject();
                // Pre populate users
                _this._setPrePopulatedEmailUsersList();
            }
            _this._buildDocumentsSectionHtml();
            if (successCallback) {
                successCallback();
            }
            _this.isExistingDocumentsAvailable = true;
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    EmailDocumentsController.prototype.addEmailDocumentFolder = function (successCallback) {
        var _this = this;
        var folder = {
            candidateId: this.candidateId,
            companyId: this.companyId,
            description: "Email Documents",
            name: "Email Documents",
            parentFolderId: null
        };
        this.documentService.addCandidateDocumentFolder(folder, function (data) {
            _this.emailDocumentFolderId = data.id;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, "danger");
        });
    };
    EmailDocumentsController.prototype.openFileSelectionModal = function () {
        document.getElementById("emailDocumentUploadDropzone").click();
    };
    EmailDocumentsController.prototype.uploadEmailDocumentToUpload = function () {
        var _this = this;
        this.$timeout(function () {
            _this.emailDocumentUploadDropzone.processQueue();
        }, 500);
    };
    EmailDocumentsController.prototype.attachDocumentsToEmail = function () {
        var _this = this;
        this.folders.map(function (folder) {
            if (folder.name === 'Email Documents') {
                _this.emailDocumentFolderId = folder.id;
            }
        });
        if (this.emailDocumentFolderId) {
            this.openFileSelectionModal();
        }
        else {
            this.addEmailDocumentFolder(function () {
                _this.openFileSelectionModal();
            });
        }
    };
    EmailDocumentsController.prototype.validateTypeAheadTags = function (tag) {
        if (!tag.id && !MESSAGECONSTANTS.VALIDATIONPATTERNS.EMAIL.test(tag.name)) {
            return null;
        }
        else {
            return tag;
        }
    };
    EmailDocumentsController.prototype._setEmailNewTag = function (tag, type) {
        this.addedEmailCount += 1;
        var tempTag = { id: this.addedEmailCount, email: tag.email, displayString: "", name: tag.name, isNewTag: true };
        switch (type) {
            case 'emailUsers':
                this.selectedEmailSendToObjectsArray = this.selectedEmailSendToObjectsArray.filter(function (data) { return data.email != tag.email; });
                this.selectedEmailSendToObjectsArray.push(tempTag);
                break;
            case 'ccUsers':
                this.selectedEmailCCObjectsArray = this.selectedEmailCCObjectsArray.filter(function (data) { return data.email != tag.email; });
                ;
                this.selectedEmailCCObjectsArray.push(tempTag);
                break;
            case 'bccUsers':
                this.selectedEmailBCCObjectsArray = this.selectedEmailBCCObjectsArray.filter(function (data) { return data.email != tag.email; });
                ;
                this.selectedEmailBCCObjectsArray.push(tempTag);
                break;
            default:
                break;
        }
        return tempTag;
    };
    EmailDocumentsController.prototype.emailTypeAheadAdded = function (tag, type) {
        if (!tag.id) {
            tag.email = tag.email ? tag.email : tag.name;
            var addNewTag = this._setEmailNewTag(tag, type);
            this.emailDetails[type].push({ email: addNewTag.email, name: addNewTag.name });
        }
        else {
            this.emailDetails[type].push(tag);
        }
        if ((!tag.id || !tag.staffingCompany) && !this.showClientForReviewCheckbox) {
            this.showClientForReviewCheckbox = true;
        }
    };
    EmailDocumentsController.prototype.emailTypeAheadRemoved = function (tag, type) {
        this.emailDetails[type] = this.emailDetails[type].filter(function (email) { return email.email != tag.email; });
        this.checkIfNonStaffingCompanyUserExists(this.emailDetails);
    };
    EmailDocumentsController.prototype.checkIfNonStaffingCompanyUserExists = function (emailDetails) {
        var e_3, _a, e_4, _b;
        this.showClientForReviewCheckbox = false;
        var EmailUsersFieldList = ['emailUsers', 'ccUsers', 'bccUsers'];
        try {
            for (var EmailUsersFieldList_1 = tslib_1.__values(EmailUsersFieldList), EmailUsersFieldList_1_1 = EmailUsersFieldList_1.next(); !EmailUsersFieldList_1_1.done; EmailUsersFieldList_1_1 = EmailUsersFieldList_1.next()) {
                var user = EmailUsersFieldList_1_1.value;
                try {
                    for (var _c = tslib_1.__values(emailDetails[user]), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var data = _d.value;
                        if (!data.id || !data.staffingCompany) {
                            this.showClientForReviewCheckbox = true;
                            return;
                        }
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (EmailUsersFieldList_1_1 && !EmailUsersFieldList_1_1.done && (_a = EmailUsersFieldList_1.return)) _a.call(EmailUsersFieldList_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    EmailDocumentsController.prototype._setUserToEmailSearchObject = function () {
        var _this = this;
        this.searchUsersForEmail = {};
        this.searchUsersForEmail.email = "";
        this.searchUsersForEmail.firstName = "";
        this.searchUsersForEmail.lastName = "";
        this.searchUsersForEmail.onlyRequisitionUsers = this.isRequisitionUsersSelected;
        this.searchUsersForEmail.searchInCompanies = [];
        this.searchUsersForEmail.searchString = "";
        this.searchUsersForEmail.loggedInCompanyId = this.companyId;
        if (this.candidateDetails.context == 'candidateJobMatchCard') {
            var clientOrBuId = this.candidateDetails.clientOrBuId ? this.candidateDetails.clientOrBuId : this.companyId;
            this._setCompanyUserObject(clientOrBuId, this.candidateDetails.jobMatchRequisitionId, this.candidateDetails.jobMatchId);
        }
        else {
            if (this.candidateJobMatchFolders.length > 0) {
                this.candidateJobMatchFolders.map(function (candidateJobMatch) {
                    var clientOrBuId = candidateJobMatch.jobMatch.clientOrBuId ? candidateJobMatch.jobMatch.clientOrBuId : _this.companyId;
                    _this._setCompanyUserObject(clientOrBuId, candidateJobMatch.jobMatch.jobId, candidateJobMatch.jobMatch.jobMatchId);
                });
            }
        }
        if (this.searchUsersForEmail.searchInCompanies.length === 0) {
            this.searchUsersForEmail.searchInCompanies.push({
                companyOrClientBuId: this.companyId,
                loggedInCompanyId: this.companyId,
                vendorId: this.candidateDetails.vendorId ? this.candidateDetails.vendorId : null
            });
        }
    };
    EmailDocumentsController.prototype._setCompanyUserObject = function (clientOrBuId, requisitionId, jobMatchId) {
        var companyUserObject = {
            companyOrClientBuId: this.companyId,
            requisitionId: requisitionId,
            jobMatchId: jobMatchId,
            loggedInCompanyId: this.companyId,
            vendorId: this.candidateDetails.vendorId ? this.candidateDetails.vendorId : null
        };
        this.searchUsersForEmail.searchInCompanies.push(companyUserObject);
        if (companyUserObject.companyOrClientBuId != clientOrBuId) {
            var clientUserObject = Object.assign({}, companyUserObject);
            clientUserObject.companyOrClientBuId = clientOrBuId;
            this.searchUsersForEmail.searchInCompanies.push(clientUserObject);
        }
    };
    EmailDocumentsController.prototype._filterToCcBccExistingEmails = function (data, type) {
        var existingEmailArray = [];
        var existingEmailIds = [];
        if (type === 'to') {
            existingEmailArray = tslib_1.__spread(this.selectedEmailSendToObjectsArray);
        }
        else if (type === 'cc') {
            existingEmailArray = tslib_1.__spread(this.selectedEmailCCObjectsArray);
        }
        else if (type === 'bcc') {
            existingEmailArray = tslib_1.__spread(this.selectedEmailBCCObjectsArray);
        }
        if (existingEmailArray.length > 0) {
            existingEmailArray.map(function (val) { return existingEmailIds.push(val.email); });
        }
        return data.filter(function (val) { return !existingEmailIds.includes(val.email); });
    };
    EmailDocumentsController.prototype.getEmailIds = function (searchTerm, type) {
        var _this = this;
        var tempSearchUserForEmail = _.cloneDeep(this.searchUsersForEmail);
        if (tempSearchUserForEmail) {
            tempSearchUserForEmail.searchString = searchTerm;
            tempSearchUserForEmail.onlyRequisitionUsers = this.isRequisitionUsersSelected;
            if (!tempSearchUserForEmail.onlyRequisitionUsers) {
                tempSearchUserForEmail.searchInCompanies.map(function (data) {
                    data.requisitionId = null;
                });
            }
            return this.userService.getFilteredUsersToEmail(tempSearchUserForEmail).then(function (data) {
                var filteredEmails = _this._filterToCcBccExistingEmails(data, type);
                angular.forEach(filteredEmails, function (val, key) {
                    val.name = (val.firstName ? val.firstName : "") + " " + (val.lastName ? val.lastName : "");
                    val.displayString = (val.firstName ? val.firstName : "") + " " + (val.lastName ? val.lastName : "") + " (" + val.email + " " + (val.companyName ? ", " + val.companyName : "") + ")";
                    val.isCompanyUser = _this._setCompanyUser(val);
                });
                return filteredEmails;
            });
        }
        else {
            return [];
        }
    };
    EmailDocumentsController.prototype.attach4dot5GeneratedDocuments = function (file) {
        // Updated when server side changes done
    };
    EmailDocumentsController.prototype.addNewEmployee = function () {
        var _this = this;
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        $(".modal").addClass("candidate-documents-modal");
        this.$timeout(function () {
            var candidateProfileActionsModal = _this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                windowTopClass: 'four-dot-five-modal-medium',
                component: 'candidateProfileActionsModal',
                resolve: {
                    actionType: function () {
                        return 'addEmployee';
                    },
                    actionLabel: function () {
                        return 'Add Employee';
                    }
                }
            });
            candidateProfileActionsModal.result.then(function (callbackObject) {
                //do nothing;
            }, function (dismiss) {
                //do nothing;
            });
        }, 300);
    };
    EmailDocumentsController.prototype._setCandidateAssessmentReports = function () {
        if (this.candidateDetails && this.candidateDetails.resumeFileName && this.candidateDetails.resumeFileName != '') {
            this.candidateAssessmentFiles.push({ name: "Resume", fileName: "", isSelected: false, resumeNameOrXrXml: this.candidateDetails.resumeFileName });
            this.candidateAssessmentFiles.push({ name: "Resume HR Xml", fileName: "", isSelected: false, resumeNameOrXrXml: this.candidateDetails.resumeXRXml });
        }
    };
    EmailDocumentsController.prototype._setEmailBodyPrePopulatedInformation = function (addCandidateInformation) {
        var _this = this;
        var prePopulatedEmailSignature = "<p><br/></p><p><br/></p><p><br/></p><p id=\"signature\">Thank You!</p><p><b>" + this.loggedInUserName + "</b></p><br/><br/>";
        this.emailDetails.body = prePopulatedEmailSignature;
        this.displayedBody = prePopulatedEmailSignature;
        // Update the actual editor DOM to keep it in sync with the model
        this.$timeout(function () {
            var editorElem = document.querySelector('.ta-bind');
            if (editorElem) {
                editorElem.innerHTML = _this.emailDetails.body;
            }
        }, 100);
    };
    EmailDocumentsController.prototype.addTagOnTab = function (event, type) {
        if (event.originalEvent.keyCode == 9) {
            if (this.inputTypeAheadText[type] != '' && MESSAGECONSTANTS.VALIDATIONPATTERNS.EMAIL.test(this.inputTypeAheadText[type])) {
                event.preventDefault();
                var inputEmailText = this.inputTypeAheadText[type];
                var newTag = { id: null, email: inputEmailText, displayString: "", name: inputEmailText };
                this.emailTypeAheadAdded(newTag, type);
                this.inputTypeAheadText[type] = '';
            }
        }
    };
    EmailDocumentsController.prototype._setPrePopulatedEmailUsersList = function (jobMatchId) {
        var _this = this;
        var jobMatchIdsArray = [];
        var jobMatchIds = "";
        if (jobMatchId) {
            jobMatchIdsArray.push(jobMatchId);
        }
        else {
            if (this.candidateJobMatchFolders.length > 0) {
                this.candidateJobMatchFolders.map(function (data) {
                    jobMatchIdsArray.push(data.jobMatch.jobMatchId);
                });
            }
        }
        jobMatchIds = jobMatchIdsArray.toString();
        this.userService.getUsersToPrePopulate(this.companyId, this.isRequisitionUsersSelected, jobMatchIds).then(function (data) {
            var selectedUsersIds = _this.selectedEmailSendToObjectsArray.length > 0 ? _this.selectedEmailSendToObjectsArray.map(function (selectedEmail) { return selectedEmail.id; }) : _this.selectedEmailSendToObjectsArray;
            data.map(function (prePopulatedUser) {
                if (prePopulatedUser && prePopulatedUser.id && !selectedUsersIds.includes(prePopulatedUser.id)) {
                    prePopulatedUser.name = (prePopulatedUser.firstName ? prePopulatedUser.firstName : "") + " " + (prePopulatedUser.lastName ? prePopulatedUser.lastName : "");
                    prePopulatedUser.isCompanyUser = _this._setCompanyUser(prePopulatedUser);
                    if (_this.selectedEmailCCObjectsArray.every(function (user) { return user.id != prePopulatedUser.id; })) {
                        if (_this.candidateDetails && _this.candidateDetails.candidateEmail) {
                            _this.selectedEmailCCObjectsArray.push(prePopulatedUser);
                            _this.emailDetails.ccUsers.push(prePopulatedUser);
                        }
                        else {
                            _this.selectedEmailSendToObjectsArray.push(prePopulatedUser);
                            _this.emailDetails.emailUsers.push(prePopulatedUser);
                        }
                    }
                }
                if (prePopulatedUser && !prePopulatedUser.staffingCompany) {
                    _this.showClientForReviewCheckbox = true;
                }
            });
            _this.isPrePopulatedUsersAvailable = true;
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, "danger");
            _this.isPrePopulatedUsersAvailable = true;
        });
    };
    EmailDocumentsController.prototype._setCompanyUser = function (prePopulatedUser) {
        var isCompanyUser = false;
        if (!this.isStaffingCompany) {
            if (prePopulatedUser.staffingCompany) {
                isCompanyUser = true;
            }
        }
        else {
            isCompanyUser = prePopulatedUser.staffingCompany;
        }
        return isCompanyUser;
    };
    EmailDocumentsController.prototype.getCustomTagClass = function (tag) {
        if (tag.isNewTag) {
            return 'new-email-user-tag';
        }
        else {
            if (this.isStaffingCompany) {
                if (tag && !tag.isCompanyUser) {
                    return 'other-company-user-tag';
                }
            }
            else {
                if (tag && tag.isCompanyUser) {
                    return 'other-company-user-tag';
                }
            }
        }
    };
    EmailDocumentsController.prototype.onTagClicked = function (tag) {
        if (tag.name == tag.email) {
            if (tag.id && (tag.firstName || tag.lastName)) {
                tag.name = tag.originalName.slice();
            }
        }
        else {
            tag.originalName = tag.name;
            tag.name = tag.email;
        }
    };
    EmailDocumentsController.prototype.getCustomAutoCompleteClass = function (match, selected) {
        if (match) {
            if (this.isStaffingCompany) {
                if (!match.isCompanyUser && selected == false) {
                    return 'other-company-auto-complete-user-tag';
                }
                else if (!match.isCompanyUser && selected == true) {
                    return 'other-company-auto-complete-user-tag-selected';
                }
            }
            else {
                if (match.isCompanyUser && selected == false) {
                    return 'other-company-auto-complete-user-tag';
                }
                else if (match.isCompanyUser && selected == true) {
                    return 'other-company-auto-complete-user-tag-selected';
                }
            }
        }
    };
    EmailDocumentsController.prototype.viewDocumentFIle = function (file) {
        this.sharedAjsService.viewDocumentFIle(file, function (data) {
        }, function (error) {
        });
    };
    EmailDocumentsController.prototype._handleFilterDisplay = function () {
        $(document).ready(function () {
            var panel = $("#candidate-information-panel");
            var chevronDown = $("#open-candidate-information-filter .fa-chevron-down");
            var chevronUp = $("#open-candidate-information-filter .fa-chevron-up");
            // Initially hide panel and set icon state
            panel.hide();
            chevronUp.hide();
            chevronDown.show();
            // Remove old handlers to avoid duplicates
            $(document)
                .off("click", "#open-candidate-information-filter")
                .on("click", "#open-candidate-information-filter", function () {
                // Toggle the panel
                panel.animate({ height: "toggle" }, 200, function () {
                    // After animation completes, toggle icon visibility
                    if (panel.is(":visible")) {
                        chevronDown.hide();
                        chevronUp.show();
                    }
                    else {
                        chevronUp.hide();
                        chevronDown.show();
                    }
                });
            });
        });
    };
    EmailDocumentsController.prototype._setCandidateInformationInBody = function () {
        var _this = this;
        this.candidateInformationList = [];
        var candidateInformation = ['name', 'phone_number', 'email', 'address', 'current_location', 'current_role', 'current_company', 'seeking_job_type', 'desired_salary.rate', 'sponsorship', 'willing_to_relocate', 'linkedin_url'];
        candidateInformation.map(function (candidate) {
            var name = candidate.split('_');
            var formattedName = name.map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1); }).join(' ');
            formattedName = formattedName.replace('.', '/');
            var tempObj = { id: candidate, name: formattedName, value: 'Test' + candidate, selected: false };
            _this.candidateInformationList.push(tempObj);
        });
    };
    EmailDocumentsController.prototype.addCandidateInformationToBody = function (candidate) {
        var _this = this;
        if (candidate.selected) {
            var paragraphToInsert = this._setCandidateInfoInParagraph(this.emailDetails.body, candidate);
            var originalString = this.emailDetails.body;
            var signatureIndex = originalString.indexOf("<p id=\"signature\">");
            if (signatureIndex !== -1) {
                this.emailDetails.body =
                    originalString.slice(0, signatureIndex) +
                        paragraphToInsert +
                        originalString.slice(signatureIndex);
            }
            else {
                this.emailDetails.body += paragraphToInsert;
            }
        }
        else {
            // Remove paragraph when unchecked
            var tempElement = document.createElement('div');
            tempElement.innerHTML = this.emailDetails.body;
            var pToRemove = tempElement.querySelector("span[id=\"" + candidate.id + "\"]");
            if (pToRemove) {
                pToRemove.parentNode.removeChild(pToRemove);
            }
            this.emailDetails.body = tempElement.innerHTML;
        }
        // CRITICAL: Update the actual editor DOM to keep it in sync with the model
        this.$timeout(function () {
            var editorElem = document.querySelector('.ta-bind');
            if (editorElem) {
                editorElem.innerHTML = _this.emailDetails.body;
            }
        }, 50);
    };
    EmailDocumentsController.prototype._setCandidateInfoInParagraph = function (body, candidate) {
        // Creates a simple editable paragraph
        var paragraph = "<span id=\"" + candidate.id + "\" contenteditable=\"true\">\n        <b>" + candidate.name + ":</b> " + (candidate.value || 'Not Specified') + "\n    </span>";
        return paragraph;
    };
    EmailDocumentsController.prototype.selectAllCandidateInformation = function (selectAll) {
        var _this = this;
        if (!this.candidateInformationList || this.candidateInformationList.length === 0)
            return;
        this.candidateInformationList.forEach(function (candidate) {
            candidate.selected = selectAll;
            _this.addCandidateInformationToBody(candidate);
        });
    };
    // onEmailBodyChange() {
    //     if (!this.emailDetails.body || this.emailDetails.body.trim() === '') return;
    //     let tempDiv = document.createElement('div');
    //     tempDiv.innerHTML = this.emailDetails.body;
    //     let shouldUpdate = false;
    //     this.candidateInformationList.forEach(candidate => {
    //         const pElement = tempDiv.querySelector(`p[id="${candidate.id}"]`);
    //         if (!pElement || pElement.innerText.trim() === '') {
    //             if (candidate.selected) candidate.selected = false;
    //             if (pElement) pElement.remove();
    //             shouldUpdate = true;
    //         }
    //     });
    //     if (shouldUpdate) {
    //         // Small delay lets Rangy finish restoring before updating model
    //         setTimeout(() => {
    //             this.emailDetails.body = tempDiv.innerHTML;
    //         }, 50);
    //     }
    // }
    EmailDocumentsController.prototype.onEmailBodyChange = function () {
        var editorElem = document.querySelector('.ta-bind');
        if (!editorElem)
            return;
        this.candidateInformationList.forEach(function (candidate) {
            var p = editorElem.querySelector("p[id=\"" + candidate.id + "\"]");
            if (p && p.innerText.trim() === '') {
                candidate.selected = false;
                p.remove();
            }
        });
    };
    EmailDocumentsController.prototype.emailContentChange = function (event) {
        this.emailDetails.body = event;
        this.displayedBody = event;
        // Sync document checkboxes when the documents section is manually removed from the editor.
        var editorElem = document.querySelector('app-ngx-editor [contenteditable="true"]');
        var hasDocSection;
        if (editorElem) {
            var docSection = editorElem.querySelector('#email-documents-section');
            var docHeader = editorElem.querySelector('#doc-attach-header');
            // Consider the section present only if it (or its header) has non-empty visible text.
            hasDocSection = (!!docSection && docSection.textContent.trim() !== '') ||
                (!!docHeader && docHeader.textContent.trim() !== '');
        }
        else {
            hasDocSection = event.includes('id="doc-attach-header"') || event.includes("id='doc-attach-header'");
        }
        if (!hasDocSection) {
            var hasSelectedDocs = (this.attachedDocuments && this.attachedDocuments.length > 0) ||
                (this.candidateAssessmentFiles || []).some(function (f) { return f.isSelected; });
            if (hasSelectedDocs) {
                if (this.candidateAssessmentFiles) {
                    this.candidateAssessmentFiles.forEach(function (f) { f.isSelected = false; });
                }
                this.attachedDocuments = [];
                this.documentsSectionHtml = '';
            }
        }
    };
    EmailDocumentsController.prototype.onSelectedFieldsChange = function (selectedFields) {
        var _this = this;
        // Enrich selected fields with actual values from candidateInformationList
        this.selectedCandidateFieldsForReview = selectedFields.map(function (field) {
            // Try to find the original field in candidateInformationList to get more complete data
            var originalField = _this.candidateInformationList.find(function (c) { return c.id === field.id; });
            if (originalField) {
                return {
                    id: field.id,
                    name: field.name || originalField.name,
                    value: originalField.value || field.value,
                    selected: true
                };
            }
            return field;
        });
    };
    /**
     * Called when the Angular email-html-editor emits candidateSelectionSync.
     */
    EmailDocumentsController.prototype.onCandidateSelectionSync = function (updatedList) {
        var _this = this;
        if (!updatedList || !this.candidateInformationList)
            return;
        updatedList.forEach(function (updated) {
            var local = _this.candidateInformationList.find(function (c) { return c.id === updated.id; });
            if (local) {
                local.selected = updated.selected;
            }
        });
        this.selectAllCandidatesExternal = this.candidateInformationList.every(function (c) { return c.selected; });
        // Replace array reference so AngularJS one-time / ng-repeat re-evaluates
        this.candidateInformationList = tslib_1.__spread(this.candidateInformationList);
    };
    EmailDocumentsController.prototype.onExternalSelectAll = function (checked) {
        this.selectAllCandidatesExternal = checked;
        if (this.candidateInformationList) {
            this.candidateInformationList.forEach(function (c) { return c.selected = checked; });
        }
        this.externalCandidateAction = { type: 'selectAll', selectAll: checked, timestamp: Date.now() };
    };
    EmailDocumentsController.prototype.onExternalCandidateToggle = function (candidate) {
        this.externalCandidateAction = { type: 'single', candidate: candidate, timestamp: Date.now() };
        // sync selectAllCandidatesExternal
        if (this.candidateInformationList) {
            this.selectAllCandidatesExternal = this.candidateInformationList.every(function (c) { return c.selected; });
        }
    };
    EmailDocumentsController.prototype.adjustAttachedDocumentsHeight = function () {
        var $emailFormSection = $('#emailFormSection');
        var $attachDocumentsSection = $('#attachDocumentsSection');
        var $otherDocumentsSection = $('#otherDocumentsSection');
        var $loadingSpinner = $('#loadingSpinner');
        if ($emailFormSection.length === 0 || $attachDocumentsSection.length === 0) {
            return;
        }
        var updateHeight = function () {
            var emailFormHeight = $emailFormSection.outerHeight();
            if (emailFormHeight > 0) {
                // Remove max-height from attachDocumentsSection
                $attachDocumentsSection.css('max-height', 'none');
                $attachDocumentsSection.css('overflow-y', 'visible');
                // Calculate the height used by other elements in attachDocumentsSection
                var attachDocumentsSectionHeight = $attachDocumentsSection.outerHeight();
                // Calculate remaining height for otherDocumentsSection
                var remainingHeight = emailFormHeight - 110;
                if (remainingHeight > 100) {
                    $otherDocumentsSection.css('max-height', remainingHeight + 'px');
                    $loadingSpinner.css('max-height', remainingHeight + 'px');
                }
                else {
                    $otherDocumentsSection.css('max-height', '100px');
                    $loadingSpinner.css('max-height', '100px');
                }
            }
        };
        // Initial height adjustment with delay
        this.$timeout(function () {
            updateHeight();
        }, 100);
        this.$timeout(function () {
            updateHeight();
        }, 500);
        // Observe changes
        var observer = new MutationObserver(function () {
            updateHeight();
        });
        observer.observe($emailFormSection[0], {
            attributes: true,
            childList: true,
            subtree: true,
            characterData: true
        });
        // Also observe window resize
        $(window).on('resize', updateHeight);
        // Cleanup component
        this.$rootScope.$on('$destroy', function () {
            observer.disconnect();
            $(window).off('resize', updateHeight);
        });
    };
    return EmailDocumentsController;
}());
EmailDocumentsController.$inject = ['$rootScope', '$timeout', '$uibModal', 'modalService', 'documentService', 'alertsAndNotificationsService', 'documentActionService', 'userService', 'jobMatchService', 'sharedAjsService', 'llmIntegrationService'];
// import * as TEMPLATE from './email-documents.html';
import * as TEMPLATE from 'raw-loader!./email-documents.html';
export var EmailDocumentsComponent = {
    selector: 'emailDocuments',
    component: {
        bindings: {
            context: '@',
            document: '<',
            documents: '<',
            candidateDetails: '<',
            folders: '<',
            candidateJobMatchFolders: '<',
            hasResume: '<',
            saveCallback: '&',
            cancelCallback: '&',
            sourceScreen: '@',
            formalizeActivityPayload: '<'
        },
        controller: EmailDocumentsController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/candidateprofile/candidateProfile/candidateDocuments/emailDocuments/email-documents.html'
    }
};
//# sourceMappingURL=email-documents.component.js.map